import React from 'react'
import './bydoAI.css'
import bydoLogo from "../../../../assets/bydo.webp"
const BydoAI = () => {
  return (
    <section className="relative py-20 overflow-hidden bg-white">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Floating Animated Orbs */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100 opacity-30 rounded-full blur-3xl animate-float-slow"></div>
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-100 opacity-30 rounded-full blur-3xl animate-float-medium"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-green-100 opacity-20 rounded-full blur-3xl animate-pulse-slow"></div>
        
        {/* Floating Light Particles */}
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-blue-200 rounded-full animate-float-particle opacity-60"
            style={{
              left: `${20 + (i * 10)}%`,
              top: `${30 + (i * 8)}%`,
              animationDelay: `${i * 0.5}s`,
              animationDuration: `${3 + i}s`
            }}
          />
        ))}
        
        {/* Glowing Light Rays */}
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-blue-200 to-transparent animate-light-ray opacity-40"></div>
        <div className="absolute top-0 right-1/3 w-px h-full bg-gradient-to-b from-transparent via-purple-200 to-transparent animate-light-ray opacity-30" style={{animationDelay: '1s'}}></div>
        
        {/* Subtle Moving Gradients */}
        <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-transparent via-blue-50/20 to-transparent animate-gradient-move opacity-30"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4">
        {/* Logo Section */}
        <div className="text-center mb-5">
         
          <div className="flex items-center justify-center gap-2">
                <img className='h-10' src={bydoLogo} alt="bydo logo" />
          </div>
        </div>

        {/* Main Headline */}
        <div className="text-center mb-16 max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-5xl font-bold text-gray-900 leading-tight">
            <span className="text-gray-900">Our flagship AI platform
            transforming business
           operations worldwide</span>
          </h2>
          <p className="text-lg text-gray-600 mt-6 max-w-3xl mx-auto">
            Experience the future of enterprise AI with bydo.io - where intelligence meets innovation, 
            delivering cutting-edge solutions that drive growth and efficiency.
          </p>
        </div>

        {/* Interactive Input Section 
        <div className="w-full max-w-2xl mx-auto mb-16">
          <div className="flex items-center gap-4 bg-white border-2 border-gray-200 rounded-2xl p-2 shadow-lg hover:border-blue-300 transition-all duration-300">
            <div className="flex-1 flex items-center gap-3 px-4 py-3">
              <div className="w-5 h-5 text-blue-500">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Describe your AI-powered solution..."
                className="flex-1 bg-transparent text-gray-900 placeholder-gray-500 outline-none text-lg"
              />
            </div>
            <button className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 shadow-lg hover:shadow-xl">
              Generate
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>

     Watch Video Section 
        <div className="text-center mb-20">
          <button className="inline-flex items-center gap-3 text-gray-700 hover:text-blue-600 transition-colors duration-300 group">
            <div className="w-12 h-12 bg-blue-100 group-hover:bg-blue-200 rounded-full flex items-center justify-center transition-all duration-300 shadow-md">
              <svg className="w-5 h-5 ml-1 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
            <span className="text-lg font-medium">Watch the demo</span>
          </button>
        </div>

        */}

        {/* Additional Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Bydo Campus</h3>
            <p className="text-gray-600">Revolutionary AI-powered learning management system for educational institutions</p>
          </div>
          
          <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-green-50 to-green-100 border border-green-200 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Bydo HR</h3>
            <p className="text-gray-600">Intelligent human resources platform with AI-driven recruitment and management</p>
          </div>
          
          <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 hover:shadow-lg transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">Bydo Office</h3>
            <p className="text-gray-600">Smart office automation suite that streamlines workflows and boosts productivity</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BydoAI
